import React, {useEffect, useState} from 'react'
import {sanity} from '../lib/sanity'

const COMMEMORATION_QUERY = `*[_type == "commemorationPage"][0]{
  label,
  title,
  blocks[]{
    _key,
    number,
    title,
    text
  }
}`

function WatHerdenkenWij() {
  const [page, setPage] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    sanity
      .fetch(COMMEMORATION_QUERY)
      .then((result) => {
        setPage(result)
        setLoading(false)
      })
      .catch((error) => {
        console.error(error)
        setLoading(false)
      })
  }, [])

  if (loading) return null

  if (!page) {
    return (
      <main className="min-h-screen text-[#5757fd]">
        <section className="mx-auto max-w-6xl px-6 py-24 md:py-36">
          <p className="text-lg font-sans">Geen content gevonden.</p>
        </section>
      </main>
    )
  }

  return (
    <main className="min-h-screen text-[#5757fd]">
      <section className="mx-auto max-w-6xl px-6 py-24 md:py-36">
        <div className="mb-20">
          {page.label && (
            <p className="mb-4 w-fit rounded-full bg-white/60 px-4 py-2 text-sm font-sans_bold uppercase tracking-wider">
              {page.label}
            </p>
          )}

          {page.title && (
            <h1 className="text-5xl font-sans_bold leading-[0.95] tracking-tight md:text-7xl text-start">
              {page.title}
            </h1>
          )}
        </div>

        {page.blocks?.length > 0 && (
          <div className="space-y-6">
            {page.blocks.map((block, index) => {
  const number = String(index + 1).padStart(2, '0')

  return (
              <article
                key={block._key}
                id={`section-${number}`}
                className="scroll-mt-36 group rounded-[2rem] bg-white/60 p-6 transition-all duration-300 hover:bg-white hover:shadow-[0_18px_40px_rgba(87,87,253,0.16)] md:grid md:grid-cols-[110px_1fr] md:gap-10 md:p-10"
              >
                {number && (
                  <div className="mb-6 md:mb-0">
                    <span className="flex h-16 w-16 items-center justify-center rounded-full bg-[#5757fd] text-xl font-sans_bold text-white md:h-20 md:w-20 md:text-2xl">
                    {number}
                    </span>
                  </div>
                )}

                <div>
                  {block.title && (
                    <h2 className="text-lg font-sans_bold">
                      {block.title}
                    </h2>
                  )}

                  {block.text && (
                    <p className="text-lg font-sans leading-tight md:text-xl whitespace-pre-line">
                      {block.text}
                    </p>
                  )}
                </div>
              </article>
              )
            })}

          </div>
        )}
      </section>
    </main>
  )
}

export default WatHerdenkenWij